import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useResolvedCompanyCtx } from '@contexts/ResolvedCompanyContext/ResolvedCompanyProvider';
import * as React from 'react';
import { GuideButton } from './GuideButton';
import { GuideOverlay } from './GuideOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Renders the guide button and the guide content, if there is any.
 */
export var ApplicationGuide = function ApplicationGuide() {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isGuideOpen = _React$useState2[0],
      setIsGuideOpen = _React$useState2[1];

  var closeGuide = React.useCallback(function () {
    setIsGuideOpen(false);
  }, []);

  var _useResolvedCompanyCt = useResolvedCompanyCtx(),
      resolvedBranch = _useResolvedCompanyCt.resolvedBranch;

  var guideLength = resolvedBranch.instructions.length;
  var hasGuide = guideLength > 0;

  if (!hasGuide) {
    return null;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GuideButton, {
      openGuide: function openGuide() {
        return setIsGuideOpen(true);
      }
    }), /*#__PURE__*/_jsx(GuideOverlay, {
      isOpen: isGuideOpen,
      onClose: closeGuide
    })]
  });
};